import Box from "@material-ui/core/Box";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React from "react";
import SpinnerSvg from "../img/spinner-clock.svg";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      flex: 1,
      height: "100%",
    },
    spinner: {},
  })
);

export const Loading: React.FC = (props) => {
  const classes = useStyles(props);

  return (
    <Box className={classes.root}>
      <Box className={classes.spinner} role="img" aria-label="Loading">
        <SpinnerSvg />
      </Box>
    </Box>
  );
};

export default Loading;
